import { CalendarSyncIcon, Cog, Megaphone, ScrollText, Siren, UserCircle } from 'lucide-react';

import type { RouteListItem } from '@/types';

import ApiIntegration from '../images/icons/api-integration.svg?react';

export const teamMembersSubNav: RouteListItem[] = [
  {
    path: '/team-members/$id',
    icon: UserCircle,
    name: 'Team Member',
    auditKey: 'team-member/profile',
  },
  {
    path: '/team-members/$id/personal-details',
    icon: ScrollText,
    name: 'Personal Details',
    auditKey: 'team-member/personal-details',
  },
  {
    path: '/team-members/$id/emergency',
    icon: Siren,
    name: 'Emergency',
    auditKey: 'team-member/emergency',
  },
  {
    path: '/team-members/$id/marketing',
    icon: Megaphone,
    name: 'Marketing',
    auditKey: 'team-member/marketing',
  },
  {
    path: '/team-members/$id/commission-periods',
    icon: CalendarSyncIcon,
    name: 'Commission Periods',
    auditKey: 'team-member/commission-periods',
  },
  {
    path: '/team-members/$id/api-integration',
    icon: ApiIntegration,
    name: 'API Integrations',
    auditKey: 'team-member/api-integration',
  },
  {
    path: '/team-members/$id/preference',
    icon: Cog,
    name: 'Preference',
    auditKey: 'team-member/preference',
  },
];
